import { createSlice } from "@reduxjs/toolkit";
import { getPartnerAnalytics } from "./_partnerAnalyticsAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const partnerAnalytics = createSlice({
  name: "partnerAnalytics",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPartnerAnalytics.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getPartnerAnalytics.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data || [];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;
      })
      .addCase(getPartnerAnalytics.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
